export default __webpack_public_path__ + "static/media/t_12_2022.351806b0.png";